export enum PromotionTypes {
    GameSessionPromotion = 'GameSessionPromotion',
    MultiSetsPromotion = 'MultiSetsPromotion',
    MultiSetsMulticampaignPromotion = 'MultiSetsMulticampaignPromotion',
    SingleSetPromotion = 'SingleSetPromotion',
    NULL = 'Null',
}
